export const aboutData = {
    title: "Who I am",
    description1: "My name’s Kavindu. I’m a developer and tech enthusiast based in Sri Lanka.",
    description2: "I’m committed to continuous learning and enjoy exploring new technologies. With experience across various areas of software development, I approach every project with focus and problem-solving skills. I have a particular interest in artificial intelligence and machine learning.",
    image: 2
}